module.exports = __webpack_public_path__ + "static/fonts/open-sans-semibold.449d681.woff";